var ostbv = ostbv || {};

ostbv.animate = new function () {
  var self = this;

  this.animateValues = function(selector){
    selector.each(function () {
      var $this = $(this),
          $statDigit = $this.find('.stats-digit'),
          statVal = parseInt( $this.attr('data-value') ),
          statDuration = (statVal * 10) > 1000 ? 1000 : (statVal * 10) < 500 ? 500 : statVal * 10;

          // Do the animate
          $({ Counter: 0 }).animate({ Counter: statVal }, {
            duration: statDuration,
            easing: 'swing',
            step: function () {
              $statDigit.text(Math.ceil(this.Counter));
            }
          });
        });
  };

  this.animateValueWhenVisible = function(selector, repeat){
    selector.each(function(){
      var $this = $(this),
          repeatAnimation = repeat !== true ? false : true;

      if( !$(this).hasClass('visible') && $(this).visible() ){
        $this.addClass('visible');
        self.animateValues($this);
      }

      // Only animate again, if repeat is set to true
      if( repeatAnimation === true && $(this).hasClass('visible') && !$(this).visible() ){
        $this.removeClass('visible');
      }

    });
  };
};

